export default __webpack_public_path__ + "static/coming-soon-6c82d65147ffebc550e1cab69d806543.png";